<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="calendar"
            modalWidth="70%"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Tipo de atributo')"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_att_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      :params="tipo_atributo"
          >
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Atributo 1')"
                       v-bind="fiOptions">
            <a-input
              v-decorator="['att_value1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Atributo 2')"
                       v-bind="fiOptions">
            <a-input-number style="width: 100%"
                            v-decorator="['att_value2', { rules: [{ required: false}] }]"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha límite')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['att_value3', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha pago')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['att_value4', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  export default {
    data () {
      return {
        tipo_atributo: {
          h_lookup_type: 'TIPO_ATRIBUTO_CALENDARIO',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Trabajo realizado', column: 'work'},
            {label: 'Estado', column: 'status_desc'},
            {label: 'Cantidad de horas', column: 'n_hours'}
          ],
          endpoint: 'calendars_att',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Tipo de atributo', dataIndex: 'id_h_att_type_desc', sorter: true},
              {title: 'Atributo 1', dataIndex: 'att_value1', sorter: true},
              {title: 'Atributo 2', dataIndex: 'att_value2', sorter: true},
              {title: 'Atributo 3', dataIndex: 'att_value3_desc', sorter: true},
              {title: 'Atributo 4', dataIndex: 'att_value4_desc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true},
            ],
            modalFieldsSetup: [
              {name: 'id_h_att_type'},
              {name: 'att_value1'},
              {name: 'att_value2'},
              {name: 'att_value3'},
              {name: 'att_value4'}
            ]
          }
        }
      }
    },
    props: ['id_calendar'],
    computed: {
      calendar () {
        return {
          id_calendar: this.id_calendar
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Calendario/AtributosCalendario.vue